/**
 *
 * Question
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import { QaQuestionUpdateMixin } from '@/scripts/QA/Question/mixins/QaQuestionUpdateMixin';
import { QaQuestionCommentMixin } from '@/scripts/QA/Question/mixins/QaQuestionCommentMixin';

import { swalWarning } from '@/utils/swal2';

export default {
  name: 'CommentEdit',

  mixins: [QaQuestionUpdateMixin, QaQuestionCommentMixin],

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      commentContent: '',
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_res_comment: 'res_comment',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isCommentBlank() {
      return '' === this.commentContent;
    },

    c_isCommentToolong() {
      return !this.c_isCommentBlank && this.commentContent.length > 300;
    },

    c_isCommentReady() {
      return !this.c_isCommentBlank && !this.c_isCommentToolong;
    },

    c_isSubmitDisabled() {
      return !this.c_isCanComment || this.p_objQa.i_commentCountDown || !this.c_isCommentReady;
    },
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_submitComment: 'submitComment',
    }),

    async submitComment() {
      let newComment = {
        commentTime: new Date().getTime(),
        content: '加载中...',
        qaAnswerId: this.p_objQa.qaAnswerId,
        userId: this.mg_userInfo.studentId,
        userNickName: this.mg_userInfo.nickname,
        avatar: this.mg_userInfo.avatar,
      };
      const comments = [...this.p_objQa.comments];
      this.updateObjQa(this.p_objQa, {
        comments: [...comments, newComment],
      });
      await this.ma_submitComment({
        answerId: this.p_objQa.qaAnswerId,
        comment: this.commentContent,
      });
      if (200 === this.ms_res_comment.status) {
        newComment = {
          ...newComment,
          content: this.commentContent,
        };
        this.updateObjQa(this.p_objQa, {
          comments: [...comments, newComment],
          i_commentIsOpen: false,
        });
        this.commentContent = '';
      } else {
        this.updateObjQa(this.p_objQa, {
          comments,
        });
        swalWarning('评论出错，请重试！');
      }
    },
  },
};
